import React from "react";

const PenIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 301.3 261.3"
      xmlSpace="preserve"
      className="pen-icon"
    >
      <rect x="0.5" y="228.5" fill="#EA6B3" width="300.9" height="32.7" />
      <polygon
        fill="#EA6B3"
        points="0.1,149.7 0,212.4 60.7,212.4 211.6,61.5 150.1,0 "
      />
    </svg>
  );
};

export default PenIcon;
